import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {QuestionnaireEditComponent} from "./questionnaire-edit/questionnaire-edit.component";

export interface ComponentHasOpenedModal {
  hasOpenedModal: () => boolean;
}

@Injectable()
export class ModalDeactivationGuard implements CanDeactivate<ComponentHasOpenedModal> {

  canDeactivate(component: QuestionnaireEditComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log("ask to deactivate");
    return !component.hasOpenedModal();
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/modal-deactivation.guard.ts